import React, { useEffect, useRef, useState } from 'react';
import { Table, Button, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import EditableTableCell from './EditableTableCell';
import { updateVesselTable } from "../../features/Pooling/PoolingSlice";
import { EditOutlined } from '@ant-design/icons';  // Importing the pencil icon
import deleteIcon from "../../assets/icons/delete.svg";


const addThousandSeparator = (value) => {
  // Ensure the value is a valid number
  const number = parseFloat(value);

  if (isNaN(number)) {
    return ''; // Return an empty string for invalid input
  }

  // Format the number with thousand separators
  return number.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20, // Adjust to retain maximum precision if needed
  });
};

const VesselDetailsTable = ({ vesselDetailsTableData = [],activeButton, metrics,handledeleteModalVisbility,requestedVesselType }) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [editingKey, setEditingKey] = useState(''); // Store editing key for row
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const tableRef = useRef(null);
  const [parentMinHeight, setParentMinHeight] = useState('47vh');
  const [parentflextype, setparentflextype] = useState('flex-start');
  const [parentmargin, setparentmargin] = useState('flex-start');
  const dispatch = useDispatch();
  const [tableHeight, setTableHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setTableHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const minHeight = 600;
  const maxHeight = 2160;
  const minScroll = 64.5; // in vh
  const maxScroll = 64.5;

  const scrollY = Math.min(
    maxScroll,
    Math.max(minScroll, ((tableHeight - minHeight) / (maxHeight - minHeight)) * (maxScroll - minScroll) + minScroll)
  );


  useEffect(() => {
    const tableHeight = tableRef.current?.offsetHeight || 0;
    setParentMinHeight(tableHeight < window.innerHeight * 0.47 ? '47vh' : `${tableHeight}px`);
    setparentflextype(tableHeight < window.innerHeight * 0.48 ? 'flex-start' : `flex-start`);
    setparentmargin(tableHeight < window.innerHeight * 0.48 ? '1vh' : `0vh`);
  }, [vesselDetailsTableData,metrics]);



  const handleViewDetails = (row) => {
    setSelectedRow(row);
    const data = row;
    let type;
  
    if (data.is_my_vessel == true) {
      type = "edit";
    } else {
      type = "view";
    }
    console.log("type",type)
    navigate('/OnBoarding', { state: { rowData: data, type: type } });
  };


  const columns = [
    {
      title: <span style={{ fontWeight: '400',display:"flex", justifyContent:"center" }}>Token ID</span>,
      dataIndex: 'column1',
      key: 'column1',
      width: "13vw",
      render: (_, row) => (
        <div>
          <span>{row.token_id}</span>
          {/* <br /> */}
          {/* <div style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
            <span
              style={{
                display: 'inline-block',
                width: '1vh',
                height: '1vh',
                backgroundColor: row.cb_wants_to_sell > 0 ? '#0CC876' : 'red',
                borderRadius: '50%',
              }}
            ></span>
            <span>{row.cb_wants_to_sell > 0 ? 'Surplus' : 'Deficit'}</span>
          </div> */}
        </div>
      ),
    },
    ...(activeButton?.toLowerCase().startsWith("my vessels")
      ? [
          {
            title: <span style={{ fontWeight: '400' }}>Vessel Name</span>,
            dataIndex: 'vessel_name',
            key: 'vessel_name',
            width: "10vw",
          },
        ]
      : []),    
    ...(user.role === "Admin Pooling Agent" && user.username.toLowerCase()!="aditya-pool@admin" ? [
      {
        title: <span style={{ fontWeight: '400' }}>Brokerage <br/> (%)</span>,
        dataIndex: 'broker_percentage',
        key: 'broker_percentage',
        align: 'center',
        width: "9vw",
        editable: true,
        render: (_, record) => (
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
            <EditableTableCell
              editable={editingKey === record.key}
              children={(record.broker_percentage || 0).toFixed(2)} 
              record={record}
              title="broker_percentage"
              setEditingKey={setEditingKey} // Set the editing key
              handleSave={handleSave} // Handle save action
              handleEdit={handleEdit} // Handle edit action
            />
            {/* Conditionally render the Edit button */}
            {editingKey !== record.key && (
              <EditOutlined
                style={{ cursor: 'pointer', fontSize: '2.5vh', color: '#678DFF' }}
                onClick={() => handleEdit(record.key)} // Trigger edit on pencil icon click
              />
            )}
          </div>
        ),
      },
    ] : []),
    {
      title: <span style={{ fontWeight: '400' }}>Year</span>,
      dataIndex: 'year',
      key: 'year',
      align: 'center',
      width: "8vw",
    },
    {
      title: <span style={{ fontWeight: '400' }}>C.B. <br/> (MT CO<sub>2</sub>e)</span>,
      dataIndex: 'column3',
      key: 'column3',
      align: 'center',
      render: (text) => (text<0 ? <span style={{ color: '#FB2F2F' }}>{Math.abs(text)}</span> : <span style={{ color: '#0CC876' }}>{Math.abs(text)}</span>),

    },
    {
      title: <span style={{ fontWeight: '400' }}>FEUM Penalty <br/>(€)</span>,
      dataIndex: 'column4',
      key: 'column4',
      align: 'center',
      render: (text) => (text!=0 ? <span style={{ color: '#FB2F2F' }}>{addThousandSeparator(text)}</span> : <span style={{ color: '#0CC876' }}>{addThousandSeparator(text)}</span>),
    },
    {
      title: <span style={{ fontWeight: '400' }}>Expected Price <br/>(€/MT CO<sub>2</sub>e)</span>,
      dataIndex: 'column5',
      key: 'column5',
      align: 'center',
      render: (_, row) => (
        <span style={{ color: '#678DFF' }}>
          {addThousandSeparator(row.expected_price_lv)} - {addThousandSeparator(row.expected_price_uv)}
        </span>
      ),
    },
    {
      title: <span style={{ fontWeight: '400' }}>GHGIE</span>,
      dataIndex: 'column6',
      key: 'column6',
      align: 'center',
      width: "8vw",
      render: (text) => <span style={{ color: '#678DFF' }}>{text}</span>,
    },
    ...(user.role === "Admin Pooling Agent" && user.username.toLowerCase()!="aditya-pool@admin" ? [
      {
        title: <span style={{ fontWeight: '400',display:"flex", justifyContent:"center" }}>PIC</span>,
        dataIndex: 'column7',
        key: 'column7',
        align: "left",
        render: (text) => <span style={{ fontWeight: '500' }}>{text}</span>,
      },
    ] : []),
    ...(user.role === "Admin Pooling Agent" && user.username.toLowerCase()!="aditya-pool@admin" ? [
      {
        title: <span style={{ fontWeight: '400',display:"flex", justifyContent:"center" }}>PIC Company</span>,
        dataIndex: 'pic__company_name',
        key: 'pic__company_name',
        align: "left",
        render: (text) => <span style={{ fontWeight: '500' }}>{text}</span>,
      },
    ] : []),
    ...(requestedVesselType=="my_vessels" ? [
    {
      title: <span sstyle={{ fontWeight: '400',display:"flex", justifyContent:"center" }}>Actions</span>,
      dataIndex: 'column8',
      key: 'column8',
      align: "center",
      render: (_, row) => (
        <div className='actions-vessel-details-table'>
          <Button
            style={{
              backgroundColor: '#678DFF',
              color: '#FFFFFF',
              borderRadius: '8px',
              display:"flex",
              justifyContent:"center",
              alignItems:"center",
              transition: 'transform 0.1s ease', // Smooth transition for scaling
              width: '6rem',
              height: '2rem',
              fontSize: '14px',
              fontWeight: '500',
            }}
            onClick={() => handleViewDetails(row)}
            onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.95)'} // Pressed effect
            onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'} // Return to normal
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'} // Return to normal when hover leaves
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'} // Hover effect (scale to 1.05)
          >
            {row.is_my_vessel === true ? "View/Modify" : "View Details"}
          </Button>
          {/* {row.is_my_vessel === true ? 
              <Button className="delete-pool-button" onClick={()=>handledeleteModalVisbility(row.token_id)}><img src={deleteIcon} alt="Delete Pool"/></Button>
            :
              ""
          } */}
        </div>    
      
      ),
    }
  ] : []),
    
  ];

  const handleSave = async (key, record, value) => {
    try {
      await dispatch(updateVesselTable({ token_id: record.token_id, broker_percentage: value }));
      notification.success({
        message: 'Success',
        description: 'Broker percentage updated successfully.',
      });
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to update broker percentage. Please try again.',
      });
    }
  };

  const handleEdit = (key) => {
    setEditingKey(key); // Set the editingKey when the user clicks on a row
  };

  const data = vesselDetailsTableData
  .sort((a, b) => a.token_id.localeCompare(b.token_id)) // Sort by token_id alphabetically
  .map((item, index) => ({
    key: index + 1,
    column1: item.token_id,
    ...(user.role === "Admin Pooling Agent" && { vessel_name: item.vessel_name }),
    year: item.year,
    ...(user.role === "Admin Pooling Agent" && { broker_percentage: item.broker_percentage }), // Conditionally add broker_percentage
    column3: (Math.floor(item.cb_wants_to_sell / 10 ** 6 * 1000000) / 1000000).toFixed(6),
    column4: item.penalty,
    column5: {
      expected_price_lv: item.expected_price_lv,
      expected_price_uv: item.expected_price_uv,
    },
    column6: item.ghg_intensity,
    ...(user.role === "Admin Pooling Agent" && { column7: item.pic__name }),
    column8: "View Details",
    editable: false,
    pic__company_name : item?.pic__company_name,
    ...item,
  }));


  return (
    <div
      className="vessel-details-table"
      style={{
        minHeight: parentMinHeight,
        justifyContent: parentflextype,
        marginTop:parentmargin,
      }}
    >
      <Table
        ref={tableRef}
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered={true}
        rowClassName="table-row"
        className="custom-vessel-details-table bordered-table"
        scroll={{ y: `${scrollY}vh` }}
      />
    </div>
  );
};

export default VesselDetailsTable;
